import {
  Disc3,
  Settings,
  MoveHorizontal,
  LayoutPanelLeft,
  DoorOpen,
  Siren,
  ShieldAlert,
  Cable,
  CircleDot,
  KeyRound,
  ArrowRight,
} from "lucide-react";
import { SERVICES, BUSINESS } from "@/data/business";
import { SERVICE_IMAGES } from "@/data/gallery";

const ICONS = {
  Coil: Disc3,
  Settings: Settings,
  AlignHorizontalDistributeCenter: MoveHorizontal,
  LayoutPanelLeft: LayoutPanelLeft,
  DoorOpen: DoorOpen,
  Siren: Siren,
  ShieldAlert: ShieldAlert,
  Cable: Cable,
  CircleDot: CircleDot,
  KeyRound: KeyRound,
};

export default function Services() {
  return (
    <section id="services" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-600">
            What We Fix
          </p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">
            Garage Door Repair Services
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            From snapped springs to full new installs, our local technicians
            handle every kind of garage door problem — quickly and the right way.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200 rounded-sm overflow-hidden">
          {SERVICES.map((s) => {
            const Icon = ICONS[s.icon] || Settings;
            const img = SERVICE_IMAGES[s.title];
            return (
              <div
                key={s.title}
                className="group bg-white flex flex-col transition-all hover:bg-slate-50 relative overflow-hidden"
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <span className="absolute left-0 top-0 h-full w-1 bg-red-600 scale-y-0 group-hover:scale-y-100 origin-top transition-transform z-10" />
                {img && (
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={img.src}
                      alt={img.alt}
                      loading="lazy"
                      width="768"
                      height="512"
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute -bottom-5 left-5 grid place-items-center h-11 w-11 rounded-sm bg-slate-900 text-red-600 shadow-lg group-hover:bg-red-600 group-hover:text-white transition-colors">
                      <Icon className="h-5 w-5" />
                    </div>
                  </div>
                )}
                <div className="p-7 pt-9 flex flex-col items-start">
                  <h3 className="font-heading text-xl font-bold text-slate-900">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-slate-600 leading-relaxed">{s.desc}</p>
                  <a
                    href="#quote"
                    className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-slate-900 group-hover:text-red-700 transition-colors"
                  >
                    Request service
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
          <p className="text-slate-600 font-medium">
            Not sure what's wrong with your door?
          </p>
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-bold px-6 py-3 rounded-sm transition-colors"
            data-testid="services-call-button"
          >
            Talk to a tech — {BUSINESS.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
}
